import { Component, Input, Output, EventEmitter } from '@angular/core';

import { Review } from 'src/app/core/services/organization/organization.model';

@Component({
  selector: 'app-organization-references',
  templateUrl: './organization-references.component.html'
})
export class OrgnizationRefencesComponent {
  recommendation: string = '';
  is_anonymous: boolean = false;

  @Input() readonly: boolean;
  @Input() reviews: Review[];

  @Output() publish = new EventEmitter<{
    recommendation: string;
    is_anonymous: boolean;
  }>();

  onSubmit() {
    const recommendation = this.recommendation;
    const is_anonymous = this.is_anonymous;

    if (!recommendation) {
      return;
    }

    this.publish.emit({ recommendation, is_anonymous });

    this.recommendation = '';
    this.is_anonymous = false;
  }
}
